// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5364":"975d99b6","9635":"2b6ecf07"}[chunkId] + ".chunk.css";
};